<ra-modal
    #mainModal
    [title]="'document.edit.coverEditor.title' | translate"
    [size]="'fullscreen'"
    [animation]="'slide-right'"
    [backdrop]="false"
    (close)="close.emit()"
>
    @if (loadingData()) {
        <div class="pane-loading">
            <ra-loading />
        </div>
    } @else {
        <div class="cover-editor">
            <div class="cover-panes">
                <!-- Rail: modelos -->
                <aside class="pane rail">
                    <section class="ctrl-section">
                        <span class="ctrl-title">{{ 'document.edit.coverEditor.templatesTitle' | translate }}</span>
                        <div class="tpl-list">
                            @for (tpl of templates(); track tpl._id ?? tpl.name) {
                                <button
                                    type="button"
                                    class="tpl-card"
                                    [class.selected]="isSelectedTemplate(tpl)"
                                    [disabled]="switchingTemplate()"
                                    (click)="selectTemplate(tpl)"
                                >
                                    <div class="tpl-thumb">
                                        @if (hasThumb(tpl)) {
                                            <img
                                                class="tpl-thumb-img"
                                                [src]="templateImage(tpl)"
                                                (error)="onThumbError(tpl)"
                                            />
                                        } @else {
                                            <ra-icon icon="gallery" varColor="contentTertiary" [size]="20" />
                                        }
                                    </div>
                                    <span class="tpl-name">{{ templateLabel(tpl) }}</span>
                                    @if (isSelectedTemplate(tpl)) {
                                        <span class="tpl-check">
                                            <ra-icon icon="check" varColor="white" [size]="13" />
                                        </span>
                                    }
                                </button>
                            }
                        </div>
                    </section>
                </aside>

                <!-- Campos -->
                <section class="pane fields">
                    <span class="ctrl-title">{{ 'document.edit.coverEditor.fieldsTitle' | translate }}</span>

                    @if (groups().length > 1) {
                        <div class="group-tabs">
                            @for (group of groups(); track group) {
                                <button
                                    type="button"
                                    class="group-tab"
                                    [class.active]="activeGroup() === group"
                                    (click)="activeGroup.set(group)"
                                >
                                    {{ groupLabel(group) }}
                                </button>
                            }
                        </div>
                    }

                    <div class="field-cards">
                        @if (isGeneralTab()) {
                            <!-- Cor de fundo: card no topo de "Gerais" (igual ao app) -->
                            <div class="field-card is-visible">
                                <div class="field-card-head">
                                    <span class="bg-color-chip" [style.background-color]="backgroundColor() || '#000000'"></span>
                                    <div class="field-card-text">
                                        <span class="field-card-title">{{ 'document.edit.coverEditor.backgroundTitle' | translate }}</span>
                                        <span class="field-card-desc">{{ 'document.edit.coverEditor.backgroundDescription' | translate }}</span>
                                    </div>
                                </div>
                                <div class="field-card-body">
                                    <div class="bg-swatches">
                                        @for (color of presetColors; track color) {
                                            <button
                                                type="button"
                                                class="bg-swatch"
                                                [class.selected]="isPresetSelected(color)"
                                                [style.background-color]="color"
                                                [attr.aria-label]="color"
                                                (click)="setBackgroundColor(color)"
                                            ></button>
                                        }
                                        <label class="bg-swatch bg-custom">
                                            <ra-icon icon="brush" varColor="contentSecondary" [size]="16" />
                                            <input
                                                type="color"
                                                [value]="backgroundColor() || '#000000'"
                                                (input)="setBackgroundColor($any($event.target).value)"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }

                        @for (item of itemsOfActiveGroup(); track item.fieldId) {
                            <div class="field-card" [class.is-visible]="item.isVisible !== false">
                                <div class="field-card-head">
                                    <div class="field-card-icon" [class.active]="item.isVisible !== false">
                                        <ra-icon
                                            [icon]="iconFor(item)"
                                            [varColor]="item.isVisible !== false ? 'accentBlue' : 'contentSecondary'"
                                            [size]="18"
                                        />
                                    </div>
                                    <div class="field-card-text">
                                        <span class="field-card-title">{{ titleFor(item) }}</span>
                                        @if (descFor(item)) {
                                            <span class="field-card-desc">{{ descFor(item) }}</span>
                                        }
                                    </div>
                                    @if (item.canHide && controlFor(item.fieldId)) {
                                        <ra-switch [formControl]="controlFor(item.fieldId)!" />
                                    }
                                </div>

                                @if (item.isVisible !== false && item.canEdit !== false) {
                                    <div class="field-card-body">
                                        @if (item.type === IMAGE) {
                                            <div class="logo-row">
                                                <div class="logo-thumb">
                                                    @if (logoUrl(item)) {
                                                        <img [src]="logoUrl(item)" alt="" />
                                                    } @else {
                                                        <ra-icon icon="gallery" varColor="contentTertiary" [size]="20" />
                                                    }
                                                </div>
                                                <div class="logo-actions">
                                                    <button
                                                        type="button"
                                                        class="logo-btn"
                                                        [class.selected]="isCompanyLogoField(item)"
                                                        (click)="useCompanyLogo(item)"
                                                    >
                                                        {{ 'document.edit.coverEditor.useCompanyLogo' | translate }}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="logo-btn"
                                                        [disabled]="logoUploadingId() === item.fieldId"
                                                        (click)="uploadImage(item)"
                                                    >
                                                        {{
                                                            (logoUploadingId() === item.fieldId
                                                                ? 'document.edit.coverEditor.uploading'
                                                                : 'document.edit.coverEditor.uploadImage'
                                                            ) | translate
                                                        }}
                                                    </button>
                                                </div>
                                            </div>
                                        } @else {
                                            <ra-link-token-composer
                                                [text]="valueText(item)"
                                                [linkTagName]="valueLinkTag(item)"
                                                [limitChar]="limitCharOf(item)"
                                                [placeholder]="'document.edit.coverEditor.inputPlaceholder' | translate"
                                                (valueChange)="onComposerChange(item, $event)"
                                            />
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </section>

                <!-- Prévia do PDF: a folha é montada aqui no navegador, com o mesmo
                     renderer que a API usa para imprimir o PDF -->
                <section class="pane preview">
                    <div class="preview-header">
                        <span class="ctrl-title">{{ 'document.edit.coverEditor.previewTitle' | translate }}</span>
                        <span class="preview-auto-hint">{{ 'document.edit.coverEditor.previewAutoUpdate' | translate }}</span>
                    </div>
                    <div class="cover-stage">
                        @if (switchingTemplate()) {
                            <div class="stage-loading">
                                <ra-loading />
                            </div>
                        }
                        @if (previewTemplate()) {
                            <div class="cover-canvas">
                                @if (pdfPreviewDoc(); as doc) {
                                    <iframe
                                        class="cover-pdf-page"
                                        [srcdoc]="doc"
                                        [title]="'document.edit.coverEditor.previewTitle' | translate"
                                    ></iframe>
                                } @else {
                                    <!-- Primeira montagem: folha em branco no lugar -->
                                    <div class="cover-pdf-page cover-pdf-skeleton"></div>
                                }
                            </div>
                        }
                    </div>
                </section>
            </div>

            <!-- Rodapé: salvar -->
            <div class="cover-footer">
                <ra-button
                    [label]="'common.save' | translate"
                    [type]="'primary'"
                    [loading]="loading()"
                    [disabled]="loadingData() || switchingTemplate()"
                    (click)="confirmSave()"
                />
            </div>
        </div>
    }
</ra-modal>
